import axios from 'axios';

export default {
  get: axios.get,
  post: axios.post
};



// WEBPACK FOOTER //
// ./src/services/http.js